import { combineReducers } from "redux";
import loanDrilldownReducer from "./loanDrilldownReducer";
import modalReducer from "./modalReducer";
import navSidebarReducer from "./navSidebarReducer";
import profileReducer from "./profileReducer";
import sidebarReducer from "./sidebarReducer";
import financingRequestsReducer from "./financingRequestsReducer";

const rootReducer = combineReducers({
  profile: profileReducer,
  financingRequests: financingRequestsReducer,
  modal: modalReducer,
  navSidebar: navSidebarReducer,
  sidebar: sidebarReducer,
  loanDrilldown: loanDrilldownReducer,
});

export default rootReducer;
